import { createPlanNameMatcher, getKeyDetailsContentIcon } from './utils/PlanMetaHelper';
import { DETAILS_CONTENT_KEYS, IPlanContent } from '../typings/planContent.types';
import { defaultEstimatesDialog, ongoingKeyDetails } from './common/planDefaults';
import { InternetOfferPerk } from './common/internetOfferPerk';

const greenPowerIncluded = {
  contentKey: DETAILS_CONTENT_KEYS.Addons,
  contentValue: '100% GreenPower add-on included in this plan',
  contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Addons),
  contentDescription: '100% GreenPower add-on included in this plan',
};

// Electricity and dual show the combined benefit-period/contract wording; gas
// keeps the shared "Ongoing contract".
const electricityKeyDetails = ongoingKeyDetails.map((detail) =>
  detail.contentKey === DETAILS_CONTENT_KEYS.BenefitPeriod
    ? {
        ...detail,
        contentDescription: 'Ongoing benefit period for electricity, ongoing contract for gas',
      }
    : detail
);

export const originPartnerAffinityVariableOngoingContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Partner Affinity Variable Ongoing']),
  content: {
    keyDetails: {
      defaultState: {
        defaultFuel: ongoingKeyDetails,
        electricity: [...electricityKeyDetails, greenPowerIncluded],
        gas: ongoingKeyDetails,
        dual: [...electricityKeyDetails, greenPowerIncluded],
      },
    },
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on an ongoing benefit period',
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
      },
    },
    perkAccordion: {
      defaultState: {
        dual: [InternetOfferPerk],
        gas: [InternetOfferPerk],
        electricity: [InternetOfferPerk],
        defaultFuel: [],
      },
    },
    onlineCredits: undefined,
    estimatesDialog: defaultEstimatesDialog(),
    uiOptions: {},
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/origin-partner-affinity-variable-ongoing/',
      },
    },
  },
};
